
<div class="main__container contenido__detalle">

	<ng-container *ngIf="( ready$ | async ); else loading">
		<ng-container *ngIf="( detalle$ | async ) as detalle; else notFound">

			<breadcrumb [title]="detalle.titulo"></breadcrumb>
			
			<div class="detalle__container">

				<div class="noticia__container">
					<div class="sector">
						<span class="sector__icon"></span>
						<div class="sector__text">{{detalle.categoria}}</div>
					</div>
					<p class="titulo">{{detalle.titulo}}</p>
					<p class="desc">{{detalle.desc}}</p>
					<img class="imagen" [src]="detalle.imagen">
					<div class="html" [innerHTML]="detalle.html"></div>
				</div>

				<!--
				<div class="noticia__more--container">
					<p>TODO: Más información relacionada con la noticia</p>
				</div>
				-->
			</div>
		</ng-container>
	</ng-container>


	<!-- Cargando -->
	<ng-template #loading>
		<div class="content loading">
			<div class="spinner-border text-info"></div>
		</div>
	</ng-template>
		
	<!-- No encontrado -->
	<ng-template #notFound>
		<h1>No encontrado</h1>
	</ng-template>	

</div>

